import { useContext } from "react";

import { FullLoading } from "./../FullLoading";
import { StoreContext } from "../../business/Provider";

export const MainContainer = ({
  nameScreen,
  alertComponent,
  children,
  dataTestId = "main-container",
  iNeedFullLoading = true,
  cancelTittle = false,
  loadingForTable = false,
}) => {
  const { loadingState, loadingContextState } = useContext(StoreContext);

  const { stateLoadingWithMessage } = loadingContextState;

  return (
    <div
      className="flex w-full h-full relative flex-col overflow-x-hidden overflow-y-hidden"
      data-testid={dataTestId}
    >
      {cancelTittle === false ? (
        <div className="flex w-full h-[5%] justify-start content-center items-center divide-x">
          <h1 className="text-[18px] font-bold ml-2 font-karla text-3xl">
            {nameScreen}
          </h1>
        </div>
      ) : null}
      <div
        className={
          "flex w-full relative " + (cancelTittle ? "h-full" : "h-[95%]")
        }
      >
        {iNeedFullLoading ? (
          <FullLoading
            loadingState={
              loadingState || stateLoadingWithMessage.loading || loadingForTable
            }
            message={stateLoadingWithMessage.message}
          />
        ) : null}
        {children}
      </div>
      {alertComponent}
    </div>
  );
};
